import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { ProfileService } from '../../process';
import { IHttpContext } from '../model';
import { HTTP_CONTEXT } from '../tokens';

export const endpointInterceptor: HttpInterceptorFn = (request, next) => {
  const { params$$ } = inject(ProfileService);

  let { url, headers } = request;

  if (params$$()?.token) {
    const authKey = `OpportunityAuthorization`;

    const authToken = `CalSale ${params$$().token}`;

    const hasHeaders = request?.headers?.keys()?.length;

    headers = hasHeaders ? headers.append(authKey, authToken) : headers.set(authKey, authToken);
  }

  const httpContext: IHttpContext = request.context.get(HTTP_CONTEXT);

  // if (httpContext?.urlModifiers) {
  //   const { urlModifiers } = httpContext;

  //   if (!urlModifiers.omitProcess) {
  //     const endpoint = findLastNotation(request.url, '/');
  //     url = `${processId$$()}/${findLastNotation(request.url, '/')}`;
  //     Console.logInfo(`not omitting process`);
  //   }
  // }

  return next(request.clone({ url, headers }));
};
